import { render, staticRenderFns } from "./ProspectsCallCenter.vue?vue&type=template&id=e0b440fa&"
import script from "./ProspectsCallCenter.vue?vue&type=script&lang=js&"
export * from "./ProspectsCallCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports